/**
 * @generated SignedSource<<ccaa2378f9419b5070ddb772384ca265>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type GenericQuery$variables = {
  id: string;
};
export type GenericQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly created?: any | null | undefined;
    readonly duration?: number | null | undefined;
    readonly file_name?: string | null | undefined;
    readonly file_size?: any | null | undefined;
    readonly file_url?: string | null | undefined;
    readonly id: string;
    readonly md5_digest?: string | null | undefined;
  } | null | undefined;
};
export type GenericQuery = {
  response: GenericQuery$data;
  variables: GenericQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          }
        ],
        "type": "OpenquakeHazardTask",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v1/*: any*/)
        ],
        "type": "OpenquakeHazardSolution",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "file_name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "file_size",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "file_url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "md5_digest",
            "storageKey": null
          }
        ],
        "type": "File",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GenericQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GenericQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ff7fd17e5a453ddff317f918d2c908ca",
    "id": null,
    "metadata": {},
    "name": "GenericQuery",
    "operationKind": "query",
    "text": "query GenericQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    id\n    ... on OpenquakeHazardTask {\n      created\n      duration\n    }\n    ... on OpenquakeHazardSolution {\n      created\n    }\n    ... on File {\n      id\n      file_name\n      file_size\n      file_url\n      md5_digest\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b085300f3a53af1298f497a29ef46f8d";

export default node;
